import Urls from '../urls.js';
import { fetch_status, fetch_json, fetch_error } from '../../../../scripts/utils/fetch.js';
import BaseView from '../../../../scripts/utils/base-view.js';

export default class AddToCartView extends BaseView {
	constructor({
		el,
		product_id,
		customer,
		quote,
		is_accessory,
		options_active
	}) {
		super(el);
		this.btn_add_to_cart = null;
		this.message_element = null;
		this.valid_product_option = false;
		this.product_data_options = null;
		this.template_url = Urls.Templates.app;

		this.product_id = product_id;
		this.customer = customer;
		this.quote = quote;
		this.quote_product = null;
		this.is_accessory = is_accessory;
		this.options_active = options_active;
		this.in_quote = false;

		this.findProductInQuote();

		if( !this.is_accessory ) {
			this.render();
			this.bindQuoteEvents();
		}

		if (this.options_active) {
			this.handleEvents();
		}
	}

	findProductInQuote () {
		if (this.quote && this.quote.Products.length > 0) {
			this.quote_product = this.quote.Products.find(product => product.ProductId === this.product_id);
			if (this.quote_product) {
				this.in_quote = true;
				this.productInQuoteEvent();
			}
		}
	}

	get_context () {
		return {
			in_quote: this.in_quote,
			label: this.el.getAttribute('data-label'),
			quote_exists: this.quote && this.quote.Products.length > 0
		};
	}

	after_render () {
		this.initSelectors();
	}

	bindQuoteEvents () {
		document.addEventListener('[add-to-quote]:add-product', () => {
			this.btn_add_to_quote.click();
		} );
	}

	initSelectors () {
		this.removeListeners();
		this.btn_add_to_quote = document.querySelector('button[name="addtoquote"]');
		this.message_element = document.querySelector('.message');
		this.addListeners();
	}

	addListeners () {
		if (this.btn_add_to_quote) {
			this.btn_add_to_quote.addEventListener('click', this.addToQuote.bind(this));
		}
	}

	removeListeners () {
		if (this.btn_add_to_quote) {
			this.btn_add_to_quote.removeEventListener('click', this.addToQuote);
		}
	}

	addToQuote (e) {
		e.preventDefault();
		if (this.in_quote) {
			this.goToQuote();
		} else {
			if (this.customer && this.customer.guest) {
				window.location = '/me/signin?next=' + window.location.pathname;
			} else {
				if (this.options_active) {
					this.getOptionsAndProceed();
				} else {
					this.addProduct();
				}
			}
		}
	}

	getOptionsAndProceed () {
		document.dispatchEvent(new CustomEvent('product-options:collect-data'));
		if (this.valid_product_option) {
			this.addProduct();
		}
	}

	addProduct () {
		const product_data = {
			ProductId: this.product_id,
			Qty: window.ProductSettings.QtyStep ? window.ProductSettings.QtyStep : 1,
			DefaultOptions: this.btn_add_to_quote.getAttribute('data-default-options')
		};

		const upd_data = this.getExternalData();
		const data = {...upd_data, ...product_data};

		this.startProgress();

		fetch(Urls.Api.product, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
			.then(fetch_status)
			.then(fetch_json)
			.then(function (json) {
				if (json.Cart) {
					this.quote = json.Cart;
				}
				this.findProductInQuote();
				this.productAdded();
			}.bind(this))
			.catch(error => {
				fetch_error(error, true)
					.then(error_json => {
						this.processError(error_json);
					});
			});
	}

	startProgress () {
		this.btn_add_to_quote.setAttribute('disabled', true);
		this.btn_add_to_quote.classList.add('progress');
	}

	endProgress () {
		this.btn_add_to_quote.removeAttribute('disabled');
		this.btn_add_to_quote.classList.remove('progress');
	}

	processError (error) {
		let message = 'Something went wrong...';

		if (error.Type && error.Type === 'SessionVerificationRequiredException') {
			if (window.verifySession) {
				window.verifySession();
			}
		} else {
			if (error && typeof error === 'object') {
				message = error.responseJSON && error.responseJSON.Message ? error.responseJSON.Message : error.Message;
			}
			this.endProgress();
			this.showError(message);
		}
	}

	showError (message) {
		if (this.message_element) {
			this.message_element.textContent = message;
			this.message_element.classList.remove('hide');
		} else {
			window.alert(message);
		}
	}

	productAdded () {
		const product_added_event = new CustomEvent('[add-to-quote]:product-added', { detail: this.quote });

		document.dispatchEvent(product_added_event);

		if (!this.el.dataset.showPane) {
			this.goToQuote();
		}
	}

	productInQuoteEvent () {
		const product_in_quote_event = new CustomEvent('[add-to-quote]:product-in-quote');

		document.dispatchEvent(product_in_quote_event);
	}

	set_state() {
		const btn_state = this.btn_add_to_quote.querySelector('span');

		this.btn_add_to_quote.classList.replace('progress', 'btn-success');
		btn_state.textContent = btn_state.getAttribute('data-state');
		this.in_quote = true;
	}

	getExternalData () {
		const product_data = {};

		if (this.adv_source) {
			product_data.Source = 'ad';
		}
		if (window.price_match_price) {
			product_data.PriceMatchPrice = window.price_match_price;
		}
		if (window.price_match_url) {
			product_data.PriceMatchUrl = window.price_match_url;
		}
		if (this.variations) {
			product_data.DefaultOptions = true;
		} else {
			product_data.Options = this.product_data_options;
		}
		if (this.map_policy === 'ADD_TO_CART') {
			product_data.UseListPrice = true;
		}

		return product_data;
	}

	goToQuote () {
		window.location.href = Urls.Api.quote;
	}

	handleEvents () {
		document.addEventListener('product-options:is_valid', event => {
			const detail = event.detail;

			if (detail) {
				this.valid_product_option = true;
			}
		});
		document.addEventListener('product-options:selected', event => {
			const detail = event.detail;

			if (detail) {
				this.product_data_options = detail;
			}
		});
	}
}
